import React from 'react';
import Date from 'assets/Date';
import Sigma from 'assets/Sigma';
import Lookup from 'assets/Lookup';
import { IIconWithTextProps } from './FilterGrid.properties';
import styles from './FieldsGrid.styles';
import { withStyles } from '@material-ui/core';
import DataArray from 'assets/DataArray';
import UserField from 'assets/UserField';

// Map of FieldType to corresponding icon components
const iconMap = {
    Date: <Date />,
    Calculated: <Sigma />,
    Lookup: <Lookup />,
    Extent: <DataArray />,
    UserField: <UserField />,
    // Add more mappings as needed
};

export const IconWithText = ({ data, classes }: IIconWithTextProps) => (<p className={classes.IconWithTextstyles}>{data.FieldLabel}{data.FieldDataType.includes('date') ? iconMap.Date : iconMap[data.FieldType] || null}</p>);

export default withStyles(styles, { index: 1 })(IconWithText);
